import React from 'react';
import { CircleAlertIcon } from 'lucide-react';
import { problems } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
export function Problem() {
  return <section className="bg-white py-16 sm:py-24" data-id="element-328" data-mp="2bexz15bu2t1u">
      <div className="mx-auto max-w-5xl px-4" data-id="element-329" data-mp="2gesnl284z6jq">
        <SectionHeading eyebrow="The Problem" title="From Disconnected References to a Structured Assessment Process" intro={<>
              <p data-id="element-331" data-mp="26gwf6i6l2ppb">
                You may already understand third molar anatomy, clinical examination, radiographic concepts, surgical indications, and
                potential complications.
              </p>
              <p className="mt-3" data-id="element-332" data-mp="1wrv0cvbryecx">
                But knowing the individual concepts doesn’t automatically tell you how to organize the information when reviewing a case.
              </p>
            </>} data-id="element-330" data-mp="2gdhj106v9urk" />

        <p className="mt-10 text-center text-lg font-bold text-ink" data-id="element-333" data-mp="1npdcydkdvfoc">You may find yourself:</p>
        <ul className="mt-5 grid gap-x-8 gap-y-1 md:grid-cols-2" data-id="element-334" data-mp="t8dn1i3q0124">
          {problems.map(item => <li key={item} className="flex items-start gap-3 border-b border-line py-4 text-base leading-relaxed text-ink/85" data-id="element-335" data-mp="oakieti2ff3y">
              <CircleAlertIcon className="mt-0.5 h-5 w-5 shrink-0 text-danger" aria-hidden="true" data-id="element-336" data-mp="xbinlf48pso4" />
              {item}
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl space-y-3 text-center text-[17px] leading-relaxed text-ink/85" data-id="element-337" data-mp="9mh8xa4tdlae">
          <p className="font-display text-2xl font-bold text-ink" data-id="element-338" data-mp="5m72jwd40sv0">
            I created Third Molar Assessment Blueprint™ to address this organizational gap.
          </p>
          <p data-id="element-339" data-mp="ek9207h73dg6">Not by promising automatic diagnoses.</p>
          <p data-id="element-340" data-mp="3n0uc5rlkcckv">Not by eliminating the need for professional training.</p>
          <p className="font-semibold text-ink" data-id="element-341" data-mp="3myrf4nlztj6n">
            But by giving you a structured visual reference that helps you organize the information you already have.
          </p>
        </div>

        <div className="mt-10" data-id="element-342" data-mp="1lyct7dwn011x">
          <CtaButton label="I Want to Organize My Third Molar Assessments" sub="Instant access · One-time payment of $27 USD · 7-day guarantee" data-id="element-343" data-mp="1qxfxgw4sm38u" />
        </div>
      </div>
    </section>;
}